import { render, staticRenderFns } from "./childList.vue?vue&type=template&id=96acdba8&scoped=true&"
import script from "./childList.vue?vue&type=script&lang=js&"
export * from "./childList.vue?vue&type=script&lang=js&"
import style0 from "./childList.vue?vue&type=style&index=0&id=96acdba8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../viewport/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96acdba8",
  null
  
)

export default component.exports